import React from "react";
import { useNavigate } from "react-router-dom";

export default function DataProtectionDemoPage() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(35px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes securePulse {
          0%,100% { transform: scale(1); box-shadow: 0 0 25px rgba(0,242,255,.30); }
          50% { transform: scale(1.06); box-shadow: 0 0 70px rgba(0,242,255,.85); }
        }

        @keyframes dataLine {
          0% { transform: translateX(-100%); opacity: 0; }
          35% { opacity: 1; }
          100% { transform: translateX(100%); opacity: 0; }
        }

        @keyframes lockFloat {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
      `}</style>

      <button onClick={() => navigate(-1)} style={styles.back}>
        ← Retour
      </button>

      <div style={styles.wrapper}>
        <div style={styles.iconCircle}>
          <div style={styles.icon}>🔐</div>
        </div>

        <h1 style={styles.title}>Protection des données</h1>

        <p style={styles.subtitle}>
          EVO-LIVE SAS accorde une attention importante au respect de la vie privée
          et à la protection des informations des utilisateurs.
        </p>

        <div style={styles.secureBox}>
          <div style={styles.dataLine}></div>

          <div style={styles.lockBlock}>
            <span style={styles.lock}>🔒</span>
            <strong>Données protégées</strong>
          </div>

          <div style={styles.lockBlock}>
            <span style={styles.lock}>👤</span>
            <strong>Vie privée respectée</strong>
          </div>

          <div style={styles.lockBlock}>
            <span style={styles.lock}>🧾</span>
            <strong>Cadre clair</strong>
          </div>
        </div>

        <div style={styles.cards}>
          <div style={styles.card}>
            <div style={styles.cardIcon}>🔐</div>
            <h3 style={styles.cardTitle}>Sécurisation</h3>
            <p style={styles.cardText}>
              Les accès et informations sensibles sont encadrés avec sérieux.
            </p>
          </div>

          <div style={styles.card}>
            <div style={styles.cardIcon}>👁️</div>
            <h3 style={styles.cardTitle}>Confidentialité</h3>
            <p style={styles.cardText}>
              Les données utilisateurs ne doivent pas être utilisées sans raison légitime.
            </p>
          </div>

          <div style={styles.card}>
            <div style={styles.cardIcon}>✅</div>
            <h3 style={styles.cardTitle}>Confiance</h3>
            <p style={styles.cardText}>
              L’objectif est de construire une plateforme saine, claire et responsable.
            </p>
          </div>
        </div>

        <p style={styles.note}>
          Cette page présente l’engagement de principe d’EVO-LIVE. Les règles détaillées
          restent précisées dans les documents officiels de la plateforme.
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background:
      "radial-gradient(circle at top right, rgba(0,242,255,0.22), transparent 34%), radial-gradient(circle at bottom left, rgba(0,145,255,0.18), transparent 32%), #03070d",
    color: "#fff",
    fontFamily: "Arial, sans-serif",
    padding: "32px 18px",
    overflowY: "auto",
    textAlign: "center",
  },

  back: {
    position: "fixed",
    top: 22,
    left: 22,
    zIndex: 20,
    padding: "11px 18px",
    borderRadius: 16,
    border: "1px solid rgba(0,242,255,0.45)",
    background: "rgba(0,12,20,0.9)",
    color: "#00f2ff",
    fontWeight: 900,
    cursor: "pointer",
    boxShadow: "0 0 18px rgba(0,242,255,0.25)",
  },

  wrapper: {
    maxWidth: 980,
    margin: "0 auto",
    paddingTop: 70,
    animation: "fadeUp 0.8s ease forwards",
  },

  iconCircle: {
    width: 135,
    height: 135,
    margin: "0 auto 28px",
    borderRadius: "50%",
    border: "2px solid rgba(0,242,255,0.7)",
    background: "rgba(0,242,255,0.08)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    animation: "securePulse 2.4s infinite",
  },

  icon: {
    fontSize: 58,
    animation: "lockFloat 2.4s infinite",
  },

  title: {
    margin: "0 0 14px",
    fontSize: "clamp(38px, 5vw, 62px)",
    color: "#fff",
    fontWeight: 900,
    textShadow: "0 0 24px rgba(0,242,255,0.8)",
  },

  subtitle: {
    maxWidth: 850,
    margin: "0 auto 34px",
    color: "#9befff",
    fontSize: 21,
    lineHeight: 1.6,
  },

  secureBox: {
    maxWidth: 760,
    margin: "0 auto 28px",
    padding: 24,
    borderRadius: 28,
    background: "rgba(0,12,20,0.82)",
    border: "1px solid rgba(0,242,255,0.35)",
    boxShadow: "0 0 35px rgba(0,242,255,0.16)",
    position: "relative",
    overflow: "hidden",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: 14,
  },

  dataLine: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(110deg, transparent 20%, rgba(0,242,255,0.16) 50%, transparent 75%)",
    animation: "dataLine 3s infinite",
  },

  lockBlock: {
    position: "relative",
    zIndex: 2,
    padding: 18,
    borderRadius: 18,
    background: "rgba(0,242,255,0.08)",
    border: "1px solid rgba(0,242,255,0.25)",
    color: "#dffcff",
    display: "flex",
    flexDirection: "column",
    gap: 10,
    alignItems: "center",
  },

  lock: {
    fontSize: 34,
  },

  cards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 16,
  },

  card: {
    padding: 24,
    borderRadius: 24,
    background: "rgba(0,12,20,0.82)",
    border: "1px solid rgba(0,242,255,0.25)",
    boxShadow: "0 0 24px rgba(0,242,255,0.10)",
  },

  cardIcon: {
    fontSize: 34,
    marginBottom: 12,
  },

  cardTitle: {
    margin: "0 0 10px",
    color: "#fff",
    fontSize: 20,
    fontWeight: 900,
  },

  cardText: {
    margin: 0,
    color: "#9befff",
    fontSize: 15,
    lineHeight: 1.5,
  },

  note: {
    maxWidth: 760,
    margin: "28px auto 0",
    padding: 16,
    borderRadius: 18,
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(0,242,255,0.18)",
    color: "rgba(230,250,255,0.72)",
    fontSize: 14,
    lineHeight: 1.5,
  },
};
